import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICreateEditAlertPayload, IEditAlertState } from "../../../common/types/alertsTypes";
import axios from "axios";
import { Status } from "../../../common/constants";
import { editAlertUrl } from "../../../config";
import { RootState } from "../../../store";
import api from "../../../api";

const EDIT_ALERT: string = "editAlert";

const initialState: IEditAlertState = {
  status: Status.IDLE,
  error: null,
  reqId: null,
  msg: null,
  alertData: null
};

interface IEditAlertResponse {
  message: string;
}

export const editAlert = createAsyncThunk(
  EDIT_ALERT,
  async ({ payload, queryParams }: { payload: ICreateEditAlertPayload; queryParams?: string }, { rejectWithValue }) => {
    try {
      const queryString = queryParams ? `?${new URLSearchParams(queryParams)}` : '';

      const response = await api.patch<IEditAlertResponse>(
        `${editAlertUrl}${queryString}`,
        payload
      );

      const editAlertResponse: IEditAlertResponse = response.data;
      return editAlertResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);


const editAlertSlice = createSlice({
  name: EDIT_ALERT,
  initialState,
  reducers: { setEditAlertData: (state: IEditAlertState, action) => {
    if(action.payload) {
      state.alertData = action.payload.alertData;
    } else {
      state.alertData = initialState.alertData;
    }
  }},
  extraReducers: (builder) => {
    builder
      .addCase(editAlert.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(editAlert.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(editAlert.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const { setEditAlertData } = editAlertSlice.actions;
export const selector = (state: RootState) => state.editAlert;
export default editAlertSlice.reducer;
